import { render, staticRenderFns } from "./custom-pagination.vue?vue&type=template&id=321bd6ea&scoped=true&"
import script from "./custom-pagination.vue?vue&type=script&lang=js&"
export * from "./custom-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321bd6ea",
  null
  
)

export default component.exports